<template>
  <v-app>
    <Login v-if="isLoggedIn"></Login>
    <v-container v-else>
      <v-layout class="pt-5" column align-center justify-center v-if="isAppLoading">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
        <h4 class="primary--text mt-5 text-center">Loading...</h4>
      </v-layout>

      <div v-else>
        <v-app-bar app dense class="db" v-if="$vuetify.breakpoint.smAndDown">
          <v-app-bar-nav-icon @click="drawer = !drawer" color="white"></v-app-bar-nav-icon>
        </v-app-bar>

        <SideNav @drawerValue="drawerEvent" :drawer="drawer"/>
        <v-content app>
          <ProfileModal :isprofileUpdated="!isprofileUpdated"/>
          <v-container :class="{'ma-4': $vuetify.breakpoint.smAndUp}">
            <router-view></router-view>
          </v-container>
        </v-content>
      </div>
    </v-container>
  </v-app>
</template>

<script>
import SideNav from "@/components/SideNav";
import ProfileModal from "@/components/ProfileModal";
import Login from "@/views/Login";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    SideNav,
    Login,
    ProfileModal
  },
  data() {
    return {
      drawer: null
    };
  },
  computed: {
    ...mapGetters(["isLoggedIn", "isprofileUpdated", "isAppLoading"])
  },
  methods: {
    drawerEvent(e) {
      if (!e) {
        this.drawer = false;
      }
    }
  }
};
</script>


<style>
*,
.poppins {
  font-family: "Poppins", sans-serif !important;
}

.r-btn {
  border-radius: 20px;
}
</style>
